import { React, useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';
import moment from 'moment';

import WaittingTopView from './WaittingTopView.js';

import FetchModule from '../../Share/Network/FetchModule.js';
import OnSitePaymentModal from './OnSitePaymentModal.js';
import RegistrationCompleteModal from './RegistrationCompleteModal.js';
import NewWaittingMemberInfo from './NewWaittingMemberInfo.js';
import WaitingProductPaymentModal from './WaitingProductPaymentModal.js';
import WaitingProductLinkoPaymentModal from './WaitingProductLinkoPaymentModal.js';

import WhiteTrashIcon from '../../../image/WhiteTrashIcon.png';
import { ReactComponent as EmptySignSvg } from '../../../image/EmptySign.svg';


const WaittingView = () => {
  const history = useHistory();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const [data, setData] = useState([]);
  const [isViewOnSitePaymentModal, setIsViewOnSitePaymentModal] = useState(false);
  const [isViewProductPaymentModal, setIsViewProductPaymentModal] = useState(false);
  const [isViewProductLinkoPayModal, setIsViewProductLinkoPayModal] = useState(false);
  const [isViewPaymentModal, setIsViewPaymentModal] = useState(false);
  const [isClickedGoMemberDetailModal, setIsClickedGoMemberDetailModal] = useState(false);
  const [memberData, setMemberData] = useState(undefined);
  const [merchantUid, setMerchantUid] = useState(undefined);
  const [index, setIndex] = useState(-1);
  const [waittingCount, setWaittingCount] = useState(0);
  const [ignoreCount, setIgnoreCount] = useState(0);
  const [isWaitting, setIsWaitting] = useState(true);
  const [approvalNum, setApprovalNum] = useState(0);
  const [rerendering, setRerendering] = useState(false);
  const [isUsePaymentSystem, setIsUsePaymentSystem] = useState(false);
  const [productData, setProductData] = useState([]);

  const [isHoverAllDelete, setIsHoverAllDelete] = useState(false);
  const [isInProgress, setIsInProgress] = useState(false);

  const WaitRef = useRef();
  const RejectRef = useRef();

  useEffect(() => {

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('member/waiting', 'GET');
        // console.log(responseData);
        if (responseData.status === 200) {
          let newData = responseData.data.waitMembers.slice();
          setIsUsePaymentSystem(responseData.data.isUsePaymentSystem);
          setData(newData);
        }
        else if (responseData.status === 401) {
          alert(t('waiting.loginRequired'));
          history.push('/');
        }
      }
    )();
  }, [rerendering, history])

  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const productRes = await fetchModule.getIndividualData('product/', 'GET');
        if (productRes.status === 200) setProductData(productRes.data);
      }
    )();
  }, [])

  useEffect(() => {
    let waittingCnt = 0;
    let ignoreCnt = 0;

    for (let i = 0; i < data.length; i++) {
      if (data[i].approval === 0) waittingCnt += 1;
      else if (data[i].approval === 2) ignoreCnt += 1;
    }

    setWaittingCount(waittingCnt);
    setIgnoreCount(ignoreCnt);
  }, [data])

  function settingWaittingView(className) {
    if (className === 'Reject') {
      setIsWaitting(false);
      setApprovalNum(2);
    }
    else {
      setIsWaitting(true);
      setApprovalNum(0);
    }
  }

  // 등록하기 버튼 클릭시 //
  function onClickAgree(userId, index) {
    setMerchantUid(data[index].merchantUid);
    setIndex(index);
    if (!data[index].isMembership && data[index].isUseLinkPay && data[index].merchantUid.split('-')[2] === '1') {
      setIsViewProductLinkoPayModal(true);
    }
    else if (!data[index].isMembership) {
      setIsViewProductPaymentModal(true);
    }
    else {
      setIsViewOnSitePaymentModal(true);
    }
  }

  // 거절하기 버튼 클릭시 //
  function onClickedIgnore(userId, index, isIgnore) {
    var value = 2;

    if (isIgnore) value = 4;
    else value = 2;

    if (value === 2) {
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postData('sales/success/' + data[index].merchantUid, 'POST');
          // 이미 결제가 된경우
          if (responseData.status === 200) {
            const refundData = await fetchModule.postData('sales/refund/' + data[index].merchantUid, 'POST');

            if (refundData.status === 200) {
              const ignoreData = await fetchModule.postDataOfCoach('registration/modify/' + data[index].id + '/' + data[index].merchantUid + '/' + userId + '/' + value, 'POST');
              // console.log(ignoreData);
              if (ignoreData.status === 200) {
                alert(t('waiting.registrationDeclined'));
                window.location.reload(true);
                // setRerendering(!rerendering);
              }
            }
          }
          // 아직 결제전
          else if (responseData.status === 203) {
            const ignoreData = await fetchModule.postDataOfCoach('registration/modify/' + data[index].id + '/' + data[index].merchantUid + '/' + userId + '/' + value, 'POST');

            if (ignoreData.status === 200) {
              alert(t('waiting.registrationDeclined'));
              window.location.reload(true);
              // setRerendering(!rerendering);
            }
          }
          else if (responseData.status === 401) {
            alert(t('waiting.loginRequired'));
            history.push('/');
          }
        }
      )();
    }
    else {
      const fetchModule = new FetchModule();
      (
        async () => {
          const ignoreData = await fetchModule.postDataOfCoach('registration/modify/' + data[index].id + '/' + data[index].merchantUid + '/' + userId + '/' + value, 'POST');

          if (ignoreData.status === 200) {
            alert(t('waiting.DeclineDeleted'));
            setRerendering(!rerendering);
          }
        }
      )();
    }
  }

  // 결제 및 회원등록 마무리 후 진행되는 메서드 //
  function onCompletePayment(memberData) {
    setIsViewOnSitePaymentModal(false);
    // console.log(memberData);

    if (memberData !== undefined) {
      setMemberData(memberData);
      setIsClickedGoMemberDetailModal(true); 
    }
  }

  // 회원 정보 자세히 보기 페이지로 이동 버튼 클릭시 //
  function onClickedGoMemberDetail() {
    history.push('/member/valid/detail/' + memberData.id);
  }

  // 등록 완료 모달 닫기 버튼 클릭시 //
  function onClickModalExit() {
    setIsClickedGoMemberDetailModal(false);
    window.location.reload(true);
  }

  // 삭제 마우스 호버링시 //
  function onMouseOverDeleteButton() {
    setIsHoverAllDelete(true);
  }

  // 삭제 마우스 호버링 끝날시 //
  function onMouseLeaveDeleteButton() {
    if (!isInProgress) setIsHoverAllDelete(false);
  }

  // 터치 디바이스에서 배경 탭 시 토글 //
  function onTouchStartBackground(e) {
    e.preventDefault();
    if (!isInProgress) setIsHoverAllDelete(prev => !prev);
  }

  // 전체 삭제 클릭시 //
  function onClickAllDelete() { 
    if (isInProgress) {
      alert(t('waiting.bulkInProgress'));
      return;
    }
    
    setIsInProgress(true);

    // 일괄 삭제 //
    if (approvalNum === 2) {
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataOfCoachVersion2('registration/delete_all/', 'POST');
  
          if (responseData.status === 200) {
            alert(t('waiting.bulkDeleteComplete'));
            setRerendering(!rerendering);
            setIsHoverAllDelete(true);
            setIsInProgress(false);
            // window.location.reload(true);
          }
        }
      )();
    }
    // 일괄 거절 //
    else {
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataOfCoachVersion2('registration/ignore_all/', 'POST');
  
          if (responseData.status === 200) {
            alert(t('waiting.bulkDeclineComplete'));
            setRerendering(!rerendering);
            setIsHoverAllDelete(true);
            setIsInProgress(false);
            // window.location.reload(true);
          }
        }
      )();
    }
  }

  return (
    <TopLevelWrapper>
      {
        isViewProductLinkoPayModal &&
          <WaitingProductLinkoPaymentModal
            userData={data[index]}
            productData={productData}
            onComplete={() => { setIsViewProductLinkoPayModal(false); window.location.reload(true); }}
            closeFn={() => setIsViewProductLinkoPayModal(false)} />
      }
      {
        isViewProductPaymentModal &&
          <WaitingProductPaymentModal
            userData={data[index]}
            productData={productData}
            onComplete={() => { setIsViewProductPaymentModal(false); window.location.reload(true); }}
            closeFn={() => setIsViewProductPaymentModal(false)} />
      }
      {
        isViewOnSitePaymentModal &&
          <OnSitePaymentModal
            isUsePaymentSystem={isUsePaymentSystem} 
            userData={data[index]} 
            merchantUid={merchantUid} 
            setMerchantUid={setMerchantUid} 
            rerendering={rerendering} 
            setRerendering={setRerendering} 
            cancel={onCompletePayment} 
            closeFn={() => setIsViewOnSitePaymentModal(false)}/>
      }
      {/* {
        isViewPaymentModal && isUsePaymentSystem &&
        <LinkoPayPaymentModal
          // onClickOnSitePayment={onClickOnSitePayment}
          // onClickLinkoPay={onClickLinkoPay}
          onClickExit={() => setIsViewPaymentModal(false)} />
      }
      {
        isViewPaymentModal && !isUsePaymentSystem &&
        <OnSitePaymentModal
          // selectedMembership={selectedMembership}
          // selectedPaymentOptions={selectedPaymentOptions}
          // selectedLockerPaymentOptions={selectedLockerPaymentOptions}
          // onClickOnSitePayment={onClickOnSitePayment}
          onClickExit={() => setIsViewPaymentModal(false)} />
      } */}
      { 
        isClickedGoMemberDetailModal && 
          <RegistrationCompleteModal 
            goFn={onClickedGoMemberDetail} 
            closeFn={onClickModalExit}/> 
      }
      <ContentWrapper>
        <WaittingTopView ref={WaitRef} isWaitting={isWaitting} waittingCnt={waittingCount} ignoreCnt={ignoreCount} settingWaittingView={settingWaittingView} />
        {
          ((approvalNum === 0 && waittingCount === 0)
          || approvalNum === 2 && ignoreCount === 0) ?
            <EmptyClassInfoBox>
              <StyledEmptySign $isDark={isDark} />
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{approvalNum === 0 ? t('waiting.noWaitingMembers') : t('waiting.noDeclinedMembers')}</Text>
            </EmptyClassInfoBox>
            :
            <InfoBoxWrapper>
              <BackgroundViewWrapper isHover={isHoverAllDelete}>
                <BackgroundView
                  isHover={isHoverAllDelete}
                  onMouseOver={onMouseOverDeleteButton}
                  onMouseLeave={onMouseLeaveDeleteButton}
                  onTouchStart={onTouchStartBackground}>
                  <BackgroundTitleViewWrapper>
                    <BackgroundTitleView
                      isHover={isHoverAllDelete}
                      onTouchStart={(e) => e.stopPropagation()}
                      onTouchEnd={(e) => { e.preventDefault(); onClickAllDelete(); }}
                      onClick={onClickAllDelete}>
                      <Image src={WhiteTrashIcon} width={20} height={20} />
                      <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='pointer'>{approvalNum === 0 ? t('waiting.bulkDecline') : t('waiting.bulkDelete')}</Text>
                    </BackgroundTitleView>
                  </BackgroundTitleViewWrapper>
                </BackgroundView>
              </BackgroundViewWrapper>
              <InfoBox isHover={isHoverAllDelete}>
                {
                  data.map((info, index) => (
                    info.approval === approvalNum &&
                    <NewWaittingMemberInfo
                      key={index}
                      index={index}
                      data={info}
                      isIgnore={approvalNum === 2}
                      isHover={isHoverAllDelete}
                      // onClickedAgree={onClickedAgree}
                      isUsePaymentSystem={isUsePaymentSystem}
                      productData={productData}
                      onClickedAgree={onClickAgree}
                      onClickedIgnore={onClickedIgnore} />
                  ))
                }
              </InfoBox>
            </InfoBoxWrapper>
        }
      </ContentWrapper>
    </TopLevelWrapper>
  )
}

export default WaittingView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-left: 27px;
  // margin-left: 42px;
  
  transition: all 0.3s ease-in-out;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const InfoBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin-top: 26px;

  width: 1035px;
`;

const BackgroundViewWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  width: 100%;
  height: 100%;

  border-radius: 15px 15px 0px 0px;

  z-index: 1;

  transition: all 0.3s ease-in-out;
`;

const BackgroundTitleViewWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 5px;

  width: 100%;
`;

const BackgroundTitleView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;

  height: 36px;

  opacity: ${props => props.isHover ? 1 : 0};

  transition: ${props => props.isHover ? 'all 0.6s ease-in-out' : 'all 0.2s ease-in-out'};

  &:hover {
    cursor: pointer;
  }
`;

const BackgroundView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  width: ${props => props.isHover ? `100%` : `68px`};
  height: ${props => props.isHover ? `100%` : `68px`};

  border-radius: ${props => props.isHover ? `15px 15px 0px 0px` : `0px 15px 0px 0px`};
  background: ${props => props.isHover
    ? `linear-gradient(180deg, rgba(217, 40, 40, 0.5) 0%, rgba(217, 40, 40, 0.1) 100%)`
    : `rgba(217, 40, 40, 0.5)`};

  transition: all 0.3s ease-in-out;
`;

const InfoBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  // margin-left: 26px;
  margin-top: ${props => props.isHover ? `50px` : `14px`};
  margin-bottom: 44px;
;
  min-height: 762px;

  gap: 16px;
  z-index: 3;

  transition: margin-top 0.3s ease-in-out;
`;


const Image = styled.img`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
`;

const StyledEmptySign = styled(EmptySignSvg)`
  width: 148px;
  height: 62px;

  & path:first-of-type {
    fill: ${props => props.$isDark ? props.theme.subBackground : props.theme.line};
  }

  & path:last-of-type {
    fill: ${props => props.theme.white};
  }

  & rect {
    fill: ${props => props.$isDark ? props.theme.line : props.theme.gray};
  }
`;

const EmptyClassInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 200px;

  // width: 100%;
  width: 1035px;
  height: 100%;

  gap: 8px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;